import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import ServicesHero from './components/ServicesHero';
import ServicesDetailed from './components/ServicesDetailed';
import ProcessTimeline from './components/ProcessTimeline';
import ServicesCTA from './components/ServicesCTA';

const Services = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  useEffect(() => {
    window.scrollTo(0, 0);

    // Set document title
    document.title = 'Digital Marketing Services India | SEO Social Media PPC GrowthLink';

    // Set meta tags
    const metaTags = [
      { name: 'description', content: 'Explore GrowthLink\'s comprehensive digital marketing services including SEO optimization, social media marketing, content strategy, PPC advertising, business consultancy, B2B marketing, email marketing, and brand development. Our expert team delivers data-driven solutions to accelerate your business growth and maximize ROI across all digital channels.' },
      { name: 'keywords', content: 'digital marketing services, SEO services, social media services, PPC advertising, business consultancy, B2B marketing, email marketing' },
      { property: 'og:title', content: 'Digital Marketing Services India | SEO Social Media PPC GrowthLink' },
      { property: 'og:description', content: 'Explore GrowthLink\'s comprehensive digital marketing services including SEO optimization, social media marketing, content strategy, PPC advertising, business consultancy, B2B marketing, email marketing, and brand development.' },
      { property: 'og:url', content: `${siteUrl}/services` },
      { name: 'twitter:title', content: 'Digital Marketing Services India | SEO Social Media PPC GrowthLink' },
      { name: 'twitter:description', content: 'Explore GrowthLink\'s comprehensive digital marketing services including SEO optimization, social media marketing, content strategy, PPC advertising, business consultancy, B2B marketing, email marketing, and brand development.' },
    ];

    metaTags.forEach(({ name, property, content }) => {
      const attribute = name ? 'name' : 'property';
      const value = name || property;
      let meta = document.querySelector(`meta[${attribute}="${value}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute(attribute, value!);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    });

    // Set canonical link
    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = `${siteUrl}/services`;

    // Set JSON-LD schema
    const schemaData = {
      "@context": "https://schema.org",
      "@type": "Service",
      "serviceType": "Digital Marketing Services",
      "provider": {
        "@type": "Organization",
        "name": "GrowthLink",
        "url": siteUrl
      },
      "areaServed": {
        "@type": "Country",
        "name": "India"
      },
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Digital Marketing Services",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "SEO Optimization",
              "description": "Comprehensive SEO services to improve your search engine rankings and organic traffic"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Social Media Marketing",
              "description": "Strategic social media campaigns to engage your audience and build brand awareness"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Content Strategy",
              "description": "Data-driven content strategies that resonate with your target audience"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "PPC Advertising",
              "description": "Targeted pay-per-click campaigns for maximum ROI"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Email Marketing",
              "description": "Personalized email campaigns that convert"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Brand Development",
              "description": "Complete brand identity and positioning services"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Business Consultancy",
              "description": "Strategic business guidance to optimize operations and drive growth"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "B2B Marketing",
              "description": "Specialized marketing strategies for business-to-business relationships and lead generation"
            }
          }
        ]
      }
    };

    let script = document.querySelector('script[type="application/ld+json"]');
    if (!script) {
      script = document.createElement('script');
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(schemaData);
  }, [siteUrl]);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-20">
        <ServicesHero />
        <ServicesDetailed />
        <ProcessTimeline />
        <ServicesCTA />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default Services;
